import styled from 'styled-components';

export const WaterTanks = styled.div`
  background: white;
  min-height: 100%;
`
